<!-- Panes -->

<div class="pane flat">
  <sui-toolbar #tb>
    <sui-checkbox
      [checked]="selectAllChecked"
      (checkedChange)="onSelectAllChange($event)"
    >
      {{ "home-actions.button.select-all" | translate }}
    </sui-checkbox>

    <app-search-input
      [placeholder]="'home-actions.placeholder.search' | translate"
      [value]="filterString"
      (inputChanged)="handleSearchStringChange($event)"
    ></app-search-input>

    <!-- Apply to selected (command menu) — no leading icon, so it stays labelled -->
    @if (applyActions.length) {
      <sui-button
        variant="ghost"
        [trailingIcon]="['fas', 'caret-down']"
        [suiPopoverTrigger]="applyPanel"
        suiPopoverPlacement="bottom-start"
        #applyTrigger="suiPopoverTrigger"
        [expanded]="applyTrigger.isOpen()"
      >
        {{ applyLabel }}
      </sui-button>
      <ng-template #applyPanel>
        <div suiPopover class="dropdown-menu">
          @for (a of applyActions; track a) {
            <a
              class="dropdown-item"
              (click)="
                a.action?.(); $event.preventDefault(); $event.stopPropagation()
              "
            >
              <span class="dropdown-item-link-col1">
                <span class="dropdown-item-link-label">
                  @if (a.icon) {
                    <div><fa-icon [icon]="a.icon"></fa-icon></div>
                  }
                  <span>{{ a.text }}</span>
                </span>
              </span>
            </a>
          }
        </div>
      </ng-template>
    }

    <!-- Status (first of the right-aligned group) -->
    <sui-button
      class="right-group-start"
      variant="ghost"
      [leadingIcon]="statusIcon"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? statusLabel : undefined"
      [suiTooltip]="tb.collapsed() ? statusLabel : ''"
      [suiPopoverTrigger]="statusPanel"
      suiPopoverPlacement="bottom-end"
      #statusTrigger="suiPopoverTrigger"
      [expanded]="statusTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : statusLabel }}
    </sui-button>
    <ng-template #statusPanel>
      <div suiPopover class="dropdown-menu">
        @if (tb.collapsed()) {
          <div class="dropdown-heading">
            {{ statusLabel }}
          </div>
        }
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(1); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'check']"></fa-icon></div>
              <span>{{ "home-actions.button.active" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="lifecycle_status"
              [checked]="lifecycleStatus === 1"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(3); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'box-archive']"></fa-icon></div>
              <span>{{ "home-actions.button.archived" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="lifecycle_status"
              [checked]="lifecycleStatus === 3"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onStatusChange(4); $event.preventDefault(); $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'trash']"></fa-icon></div>
              <span>{{ "home-actions.button.deleted" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="lifecycle_status"
              [checked]="lifecycleStatus === 4"
            />
          </span>
        </a>
      </div>
    </ng-template>

    <!-- View -->
    <sui-button
      variant="ghost"
      [leadingIcon]="['fas', 'eye']"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? viewLabel : undefined"
      [suiTooltip]="tb.collapsed() ? viewLabel : ''"
      [suiPopoverTrigger]="viewPanel"
      suiPopoverPlacement="bottom-end"
      #viewTrigger="suiPopoverTrigger"
      [expanded]="viewTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : viewLabel }}
    </sui-button>
    <ng-template #viewPanel>
      <div suiPopover class="dropdown-menu">
        @if (tb.collapsed()) {
          <div class="dropdown-heading">{{ viewLabel }}</div>
        }
        @for (item of viewItems; track item) {
          <a
            class="dropdown-item"
            (click)="
              onViewToggle(item);
              $event.preventDefault();
              $event.stopPropagation()
            "
          >
            <span class="dropdown-item-link-col1">
              <span class="dropdown-item-link-label">
                @if (item.icon) {
                  <div><fa-icon [icon]="item.icon"></fa-icon></div>
                }
                <span>{{ item.text }}</span>
              </span>
            </span>
            <span class="dropdown-item-link-col2">
              @if (item.isToggle) {
                <input type="checkbox" [checked]="item.isSelected" />
              }
              @if (item.isRadio) {
                <input
                  type="radio"
                  [name]="item.radioGroup"
                  [checked]="item.isSelected"
                />
              }
            </span>
          </a>
        }
      </div>
    </ng-template>

    <!-- Sort -->
    <sui-button
      variant="ghost"
      [leadingIcon]="sortDirIcon"
      [trailingIcon]="['fas', 'caret-down']"
      [iconOnly]="tb.collapsed()"
      [ariaLabel]="tb.collapsed() ? sortLabel : undefined"
      [suiTooltip]="tb.collapsed() ? sortLabel : ''"
      [suiPopoverTrigger]="sortPanel"
      suiPopoverPlacement="bottom-end"
      #sortTrigger="suiPopoverTrigger"
      [expanded]="sortTrigger.isOpen()"
    >
      {{ tb.collapsed() ? "" : sortLabel }}
    </sui-button>
    <fa-icon class="sort-field-icon" [icon]="sortFieldIcon"></fa-icon>
    <ng-template #sortPanel>
      <div suiPopover class="dropdown-menu">
        @if (tb.collapsed()) {
          <div class="dropdown-heading">{{ sortLabel }}</div>
        }
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('title');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'text-height']"></fa-icon></div>
              <span>{{ "home-actions.button.title" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input type="radio" name="sort" [checked]="sortField === 'title'" />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('time_created');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'clock']"></fa-icon></div>
              <span>{{ "home-actions.button.created-time" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort"
              [checked]="sortField === 'time_created'"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortFieldChange('time_modified');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'clock']"></fa-icon></div>
              <span>{{ "home-actions.button.modified-time" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort"
              [checked]="sortField === 'time_modified'"
            />
          </span>
        </a>

        <div class="dropdown-divider"></div>

        <a
          class="dropdown-item"
          (click)="
            onSortDirectionChange('asc');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div><fa-icon [icon]="['fas', 'sort-amount-up']"></fa-icon></div>
              <span>{{ "home-actions.button.ascending" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort-order"
              [checked]="sortDirection === 'asc'"
            />
          </span>
        </a>
        <a
          class="dropdown-item"
          (click)="
            onSortDirectionChange('desc');
            $event.preventDefault();
            $event.stopPropagation()
          "
        >
          <span class="dropdown-item-link-col1">
            <span class="dropdown-item-link-label">
              <div>
                <fa-icon [icon]="['fas', 'sort-amount-down']"></fa-icon>
              </div>
              <span>{{ "home-actions.button.descending" | translate }}</span>
            </span>
          </span>
          <span class="dropdown-item-link-col2">
            <input
              type="radio"
              name="sort-order"
              [checked]="sortDirection === 'desc'"
            />
          </span>
        </a>
      </div>
    </ng-template>
  </sui-toolbar>

  @if (tabContent == "workspaces") {
    <div class="scrollable-content">
      @if (!(loading$ | async)) {
        <div class="card-container-info">
          <div class="title">{{ "home.title.workspaces" | translate }}</div>
        </div>
        <div class="card-container mb-containers">
          <app-object-card-placeholder
            [type]="'workspace'"
          ></app-object-card-placeholder>
          @for (
            workspace of workspaces$ | async;
            track trackById($index, workspace)
          ) {
            <app-object-card
              [object]="workspace"
              [viewConfig]="viewConfig"
              [objectActionService]="objectActionService"
              [selectMode]="objectActionService.selectMode"
              [selected]="objectActionService.selectedObjects.has(workspace.id)"
              [filterString]="filterString"
            ></app-object-card>
          }
        </div>
      } @else {
        <app-loading></app-loading>
      }
    </div>
  }
  @if (tabContent == "recent") {
    <div class="scrollable-content">
      <div class="card-container-info">
        <div class="title">{{ "home.title.recent" | translate }}</div>
      </div>
      <div class="card-container mb-containers">
        @for (object of recentObjects$ | async; track object) {
          <app-object-card
            [object]="object"
            [objectActionService]="objectActionService"
            [selectMode]="objectActionService.selectMode"
            [selected]="objectActionService.selectedObjects.has(object.id)"
            [filterString]="filterString"
          ></app-object-card>
        }
      </div>
    </div>
  }
</div>
